import { combineReducers } from 'redux';
import SequenceManagerReducer from './SequenceManagerReducer'
import ProductOfferReducer from './ProductOfferReducer'
import ShoppingCartReducer from './ShoppingCartReducer'
import ProductOfferingQualificationReducer from './ProductOfferingQualificationReducer'
import CheckoutReducer from './CheckoutReducer';
import NumberOptionReducer from './NumberOptionReducer'
import SimOptionReducer from "./SimOptionReducer";
import ChooseNumberReducer from './ChooseNumberReducer'
import DeliveryDetailsReducer from './DeliveryDetailsReducer';
import FTTHServiceabilityReducer from './FTTHServiceabilityReducer';
import TCCEligibilityCheckReducer from './TCCEligibilityCheckReducer';
import EPlanCheckReducer from './EPlanCheckReducer';
import UnpaidBillsReducer from './UnpaidBillsReducer';
import SecurityDepositReducer from './SecurityDepositReducer';
import AbsherVerificationReducer from './AbsherVerificationReducer';
import UnifiedAbsherVerificationReducer from './UnifiedAbsherVerificationReducer';
import SuccessPageReducer from './SuccessPageReducer';
import PersonalDetailsReducer from './PersonalDetailsReducer';
import ContractLengthReducer from './ContractLengthReducer';
import AppointmentDetailsReducer from './AppointmentDetailsReducer';
import IDVerificationReducer from './IDVerificationReducer';
import CurrentNumberReducer from './CurrentNumberReducer';
import CurrentOperatorReducer from './CurrentOperatorReducer';
import FamilyPlanCheckReducer from './FamilyPlanCheckReducer';
import FTTHFlowRuleDetailsReducer from './FTTHFlowRuleDetailsReducer';
import ODBDetailsReducer from './ODBDetailsReducer';
import EnterSIMIDDetailsReducer from './EnterSIMIDDetailsReducer';
import MobilyOTPLineReducer from './MobilyOTPLineReducer';
import OTPVerificationReducer from './OTPVerificationReducer';
import MNPOTPVerificationReducer from './MNPOTPVerificationReducer';
import SIMSwapOTPVerificationReducer from './SIMSwapOTPVerificationReducer';
import DeliveryAppointmentReducer from './DeliveryAppointmentReducer';

const EcommerceReducer = combineReducers({
  SequenceManager : SequenceManagerReducer,
  ProductOffer : ProductOfferReducer, 
  ShoppingCart : ShoppingCartReducer,
  ProductOfferingQualification : ProductOfferingQualificationReducer,
  paymentMethodAndTermsConditions : CheckoutReducer,
  NumberOption : NumberOptionReducer,
  ChooseNumber : ChooseNumberReducer,
  SimOption : SimOptionReducer,
  DeliveryDetails : DeliveryDetailsReducer,
  FTTHServiceability : FTTHServiceabilityReducer,
  TCCEligibilityCheck : TCCEligibilityCheckReducer,
  EPlanCheck : EPlanCheckReducer,
  UnpaidBills : UnpaidBillsReducer,
  SecurityDeposit : SecurityDepositReducer,
  AbsherVerification : AbsherVerificationReducer,
  UnifiedAbsherVerification : UnifiedAbsherVerificationReducer,
  PersonalDetails : PersonalDetailsReducer,
  SuccessPage : SuccessPageReducer,
  ContractLength : ContractLengthReducer,
  AppointmentDetails : AppointmentDetailsReducer,
  IDVerification: IDVerificationReducer,
  CurrentNumber : CurrentNumberReducer,
  CurrentOperator: CurrentOperatorReducer,
  FamilyPlanCheck: FamilyPlanCheckReducer, 
  FTTHFlowRuleDetails: FTTHFlowRuleDetailsReducer,
  ODBDetails: ODBDetailsReducer,
  EnterSIMIDDetails: EnterSIMIDDetailsReducer,
  MobilyOTPLine: MobilyOTPLineReducer,
  OTPVerification: OTPVerificationReducer,
  MNPOTPVerification: MNPOTPVerificationReducer,
  SIMSwapOTPVerification: SIMSwapOTPVerificationReducer,
  DeliveryAppointment: DeliveryAppointmentReducer
})

export default EcommerceReducer